module.exports = __webpack_public_path__ + "img/red-square-table-2.1e9357e6.png";